/**
 * Subject and body for the form-details Email button.
 * Edit this file to change the pre-filled copy.
 */
export function getFormEmailContent({
  formName,
  guideName,
  companyName,
  activityName,
  submittedAt,
  filename,
}) {
  const title = formName || "form submission";
  const subjectParts = [title];
  if (activityName) subjectParts.push(activityName);
  if (submittedAt) subjectParts.push(submittedAt);

  const details = [
    guideName && `User: ${guideName}`,
    activityName && `Activity: ${activityName}`,
    companyName && `Company: ${companyName}`,
    submittedAt && `Submitted: ${submittedAt}`,
  ].filter(Boolean);

  const body = [
    `Hi,`,
    ``,
    `Please find the ${title} attached${filename ? ` (${filename})` : ""}.`,
    details.length ? `` : null,
    ...details,
    ``,
    `Thanks,`,
    `Opdox Admin`,
  ]
    .filter((line) => line !== null)
    .join("\n");

  return {
    subject: subjectParts.join(" – "),
    body,
  };
}
